
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prices-and-payment/gift-cards",
      function () {
        return require("private-next-pages/prices-and-payment/gift-cards.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prices-and-payment/gift-cards"])
      });
    }
  